import { shape, string, number, bool } from 'prop-types';

export const companyPropTypes = shape({
  id: number,
  active: bool,
  identificationNumber: string,
  identificationType: string,
  email: string,
  name: string,
  phone: string,
  tradeName: string
});
